import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'menus_nav_colorful',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: '#c20c0c'
    },
    styleId: [Number, String]
  },
  data: function data() {
    return {
      currentIndex: 0,
      // 滚动联动时锁定,避免点击与滚动互相触发
      lockScroll: false
    };
  },
  methods: {
    // 子级含「全部」项时,标题右侧才展示查看更多
    hasAllChild: function hasAllChild(group) {
      return (group.childrens || []).some(function (child) {
        return child.name === '全部';
      });
    },
    // 点击左侧菜单,右侧滚动定位到对应分组
    changeMenu: function changeMenu(index) {
      var _this = this;
      this.currentIndex = index;
      this.lockScroll = true;
      var target = this.$refs["group_".concat(index)];
      var groupEl = Array.isArray(target) ? target[0] : target;
      if (groupEl && this.$refs.rightAside) {
        this.$refs.rightAside.scrollTop = groupEl.offsetTop;
      }
      setTimeout(function () {
        _this.lockScroll = false;
      }, 300);
    },
    // 滚动右侧内容,自动更新左侧选中态
    handleScroll: function handleScroll() {
      var _this2 = this;
      if (this.lockScroll || !this.$refs.rightAside) {
        return;
      }
      var scrollTop = this.$refs.rightAside.scrollTop;
      var index = 0;
      this.menusList.forEach(function (item, i) {
        var target = _this2.$refs["group_".concat(i)];
        var groupEl = Array.isArray(target) ? target[0] : target;
        if (groupEl && groupEl.offsetTop - scrollTop <= 10) {
          index = i;
        }
      });
      if (index !== this.currentIndex) {
        this.currentIndex = index;
      }
    }
  },
  watch: {
    // 菜单配置变化后钳制选中索引,避免越界
    menusList: function menusList(list) {
      if (this.currentIndex > list.length - 1) {
        this.currentIndex = Math.max(0, list.length - 1);
      }
    }
  },
  computed: {
    menusList: function menusList() {
      return this.value.config.value || [];
    }
  }
};